import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import {
  $createParagraphNode,
  $createTextNode,
  $getRoot,
  $setSelection,
  COMMAND_PRIORITY_CRITICAL,
  type LexicalCommand,
  createCommand,
} from 'lexical'
import { useEffect } from 'react'

export const INSERT_SUGGESTION_COMMAND: LexicalCommand<string> = createCommand()

export function useInsertSuggestion() {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    const unregister = editor.registerCommand(
      INSERT_SUGGESTION_COMMAND,
      suggestion => {
        editor.update(
          () => {
            $setSelection(null)
            const paragraph = $createParagraphNode()
            paragraph.append($createTextNode(suggestion))

            const root = $getRoot()
            root.clear()
            root.append(paragraph)
            paragraph.selectEnd()
            editor.focus()
          },
          { tag: 'external' },
        )
        return false
      },
      COMMAND_PRIORITY_CRITICAL,
    )

    return () => {
      unregister()
    }
  }, [editor])
}
